import { inject, useSlots } from 'vue';

const dsSymbol = Symbol("FormKitDaySmart");

function useFormKitSection({ sectionKey, classKey }) {
  const context = inject(dsSymbol, {});
  const classes = context.classes?.[classKey || sectionKey];
  const slots = useSlots();
  const defaultSlotComponent = {
    render: () => slots.default()
  };
  return { context, classes, defaultSlotComponent };
}

export { dsSymbol as d, useFormKitSection as u };
//# sourceMappingURL=useFormKitSection-0P94qXKh.js.map
